import { render } from "./NoteFromPresident.vue?vue&type=template&id=641e157d&scoped=true"
import script from "./NoteFromPresident.vue?vue&type=script&lang=js"
export * from "./NoteFromPresident.vue?vue&type=script&lang=js"

import "./NoteFromPresident.vue?vue&type=style&index=0&id=641e157d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641e157d"]])

export default __exports__